import _ from 'lodash'
import { createSelector } from 'reselect'
import { groupDependentFields } from '../common/utils'
import getStrengthsAndNeeds from './helpers/InitialAssessments/getStrengthsAndNeeds'
import {
  getAllFormData,
  getInitialAssessmentsList,
  getResidentsList,
  getUsersList
} from './Lists'
import { getFormByParams } from './RiskAssessments'

const getInitialAssessmentId = (_state, props) => {
  const {
    router: {
      params: { pre_assessment_id }
    }
  } = props
  return pre_assessment_id
}
const getResidentId = (_state, props) => {
  const {
    router: {
      params: { id }
    }
  } = props
  return id
}

export const getInitialAssessments = createSelector(
  [getInitialAssessmentsList, getUsersList, getResidentsList],
  (initialAssessments, carers, residents) => {
    if (!initialAssessments || !carers) return null
    return initialAssessments.map((item) => ({
      ...item,
      editedBy: _.find(carers, { id: item.editedBy }),
      resident: _.find(residents, { id: item.resident })
    }))
  }
)

export const getInitialAssessment = createSelector(
  [
    getInitialAssessmentId,
    getInitialAssessments,
    getFormByParams,
    getResidentId,
    getResidentsList,
    getAllFormData
  ],
  (
    pre_assessment_id,
    initialAssessments,
    form,
    resident_id,
    residents,
    formData
  ) => {
    if (
      !pre_assessment_id ||
      !form ||
      !form.formFields ||
      !resident_id ||
      !residents ||
      !formData
    )
      return null

    const initialAssessment = _.find(initialAssessments, {
      id: pre_assessment_id
    })
    const resident = _.find(residents, { id: resident_id })
    const withDependsOn = groupDependentFields(form.formFields)
    const initialAssessmentFormData = formData[PRE_ASSESSMENT_FORM_ID]
      ? formData[PRE_ASSESSMENT_FORM_ID].fields
      : null
    if (initialAssessmentFormData) {
      const strengthsAndNeeds = getStrengthsAndNeeds({
        formData: initialAssessmentFormData,
        formFields: withDependsOn,
        resident
      })
      return {
        ...initialAssessment,
        ...strengthsAndNeeds
      }
    }
    return initialAssessment
  }
)

export const getResidentInitialAssessments = createSelector(
  [getResidentId, getInitialAssessments],
  (resident_id, initialAssessments) => {
    return _.filter(initialAssessments, { resident: { id: resident_id } })
  }
)

const PRE_ASSESSMENT_FORM_ID = 'editInitialAssessment'
